import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

const TitleWrapper = styled.div`
    display: flex;
    align-items: flex-end;
    margin-top: 70px;
    z-index: 3000;
    height: 300px;
    background-color: ${props => props.backgroundColor || '#DEF0F9'};
    background-image: url(${props => props.background});
    background-position: right;
    background-repeat: no-repeat;
    background-size: contain;

    ${breakpoint('lg', 'xl')`
        margin-bottom: 10px;
        height: 250px
    `}

    ${breakpoint('xs', 'lg')`
        margin-bottom: 10px;
        margin-top: 50px;
        height: 150px
    `}

    ${breakpoint('xs', 'md')`
        margin-bottom: 10px;
        margin-top: 50px;
        height: 100px;
        background-image: none;
    `}
`;

export default TitleWrapper;



// WEBPACK FOOTER //
// ./src/components/organisms/home/TitleWrapper.js